import { useEffect, useState } from "react";
import { Button, Label } from "reactstrap";
import { CurriculaService } from "../../../globals/services/curricula.service";
import styles from "../Settings.module.scss";

interface Curriculum {
    _id: string;
    entityTitle: string;
}

interface SyncCurriculaProps {
    role: string;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
}

const SyncCurricula = ({ role, isLoading, setIsLoading }: SyncCurriculaProps) => {
    const [curriculumToUpdate, setCurriculumToUpdate] = useState('All');
    const [activeCurriculaList, setActiveCurriculaList] = useState<Curriculum[]>([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [isSyncing, setIsSyncing] = useState(false);
    const isAdmin = role === 'Administrator';

    const handleSelectCurriculum = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setCurriculumToUpdate(e.target.value);
    };

    const syncCurricula = async () => {
        try {
            setIsLoading(true);
            setIsSyncing(true);
            const curriculaService = CurriculaService();
            const res = await curriculaService.syncCurricula(curriculumToUpdate);
            setSuccessMessage(res.data);
            return res;
        } catch (err) {
            console.error("Error syncing curricula", err);
        }
        finally {
            setIsLoading(false);
            setIsSyncing(false);
        }
    };

    useEffect(() => {
        const fetchCurriculaList = async () => {
            const { data } = await CurriculaService().getCurriculaList('Live');
            setActiveCurriculaList(data);
        };
        fetchCurriculaList();
    }, []);

    useEffect(() => {
        if (isLoading) {
            setSuccessMessage('');
        }
    }, [isLoading]);

    return (
        <div className="justify-content-around mb-2">
            <h3>Sync Curricula Module</h3>
            <h5 className="mt-4">
                <Label htmlFor="_status">Select Curriculum Scope to sync</Label>
            </h5>
            <select className="selectInput mr-3" id="curriculumId" value={curriculumToUpdate} onChange={handleSelectCurriculum}>
                {isAdmin && <option value="All">All</option>}
                {activeCurriculaList?.length > 0 ?
                    activeCurriculaList.map(({ _id, entityTitle }) => (
                        <option key={_id} value={_id}>{entityTitle}</option>
                    )) : (
                        <option value="" disabled>Loading...</option>
                    )}
            </select>
            <Button onClick={syncCurricula} className={`${styles.syncButton} btn btn-primary`} disabled={isLoading}>
                {isSyncing ? 'Syncing...' : 'Sync Curricula'}
            </Button>
            {successMessage && <div>{successMessage}</div>}
        </div>
    )
};

export default SyncCurricula;